<template>
  <DpaNewsBanner
    class="flex items-center justify-center gap-2"
    appearance="accent-orange">
    <UiIcon class="shrink-0 grow-0" size="sm" name="alert-filled" />
    <span>{{ message }}</span>
  </DpaNewsBanner>
</template>
<script setup lang="ts">
import UiIcon from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";

import DpaNewsBanner from "@/components/shared/DpaNewsBanner/DpaNewsBanner.vue";

defineProps<{
  message: string;
}>();
</script>
